<template>
	<div id="PagePostident">
		<div class="wrapper-fluid bg-picture-darken small-nav">


			

			<div class="container content-faq">

				<div class="row">
					<div class="col-12">
						<div class="wrapper-headlines">
							<div class="row justify-content-center">
								<div class="col-md-12 col-lg-auto">
									<h1 class="d-inline-block" >{{ $t('Account bestätigen') }}</h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 col-lg-12 wrapper-rounded-content content-answers">
						<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row justify-content-center headinline">
							<div class="col-md-9">
								<br>
								<h2>Vielen Dank für Ihre Registrierung</h2><p>Eine Bestätigungsemail wurde vergesendet. Bitte den Anweisungen in der E-Mail folgen, um den Account zu aktivieren.</p>
								<br>
							<div v-if="$route.params.result.identUrl !== null">
									<h2>Ident Verfahren</h2>
								<p>Im letzten Schritt müssen Sie sich mit ihrem Führerschein identifizieren, um Reservierungen durchführen zu können. Dies können Sie bequem online im Web oder per App durchführen.<br><br>Sie können diesen Schritt aber auch zu einem späterem Zeitpunkt durchführen.</p>
								<br>
							</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12 text-right"  v-if="$route.params.result.identUrl !== null">
								<router-link :to="{name: 'PageLogin'}"><button  class="btn btn-secondary--alt btn-wp">{{$t('Mache ich später')}}</button></router-link>
								<a :href="url" class="btn btn-primary btn-wp">{{ $t('Jetzt identifizeren') }}</a>
								<br><br><br>
							</div>
							<div class="col-12 text-center" v-else>
									<router-link :to="{name: 'PageLogin'}"><button  class="btn btn-secondary--alt btn-wp">{{$t('Jetzt einloggen')}}</button></router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PagePostident',
	data() {
	    return {
	      url : "",

	    };
	  },
	  methods: {
	    
	  },
	  mounted() {

	    	var self = this;

	    	if(!this.$route.params.result){
				// return this.$router.push({name: "PageLogin"});
			}

			self.url = this.$route.params.result.identUrl;


	  },
	   watch: {
	  },
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PagePostident.vue